import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';

interface LoginFailureDialogProps {
    open: boolean;
    onRetry: () => void;
}

const LoginFailureDialog: React.FC<LoginFailureDialogProps> = ({ open, onRetry }) => {
    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            aria-labelledby="login-failure-dialog-title"
            PaperProps={{
                sx: {
                    backgroundColor: 'black',
                    color: '#fff',
                    borderRadius: '12px',
                    minWidth: 360,
                    textAlign: 'center',
                }
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    }
                }
            }}
        >
            <DialogTitle id="login-failure-dialog-title" sx={{ py: 1.5, backgroundColor: '#1a1a1a', borderBottom: '1px solid #333' }}>
                <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
                    <ErrorOutlineIcon sx={{ fontSize: 36, color: '#ff5252' }} />
                    <Typography variant="h6" fontWeight={600} color="#fff">
                        Login Failed
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ pt: 2, backgroundColor: 'black !important' }}>
                <Typography variant="body1" color="#fff">
                    Login failure. Please try again.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3, backgroundColor: 'black !important' }}>
                <Button
                    variant="contained"
                    onClick={onRetry}
                    sx={{
                        backgroundColor: '#00677f !important',
                        color: 'whitesmoke !important',
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 4,
                        borderRadius: '6px',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 103, 127, 0.8) !important',
                        }
                    }}
                >
                    Try Again
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LoginFailureDialog;
